@if(!isOnHome){
    <div class="page-title-area">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="page-title-content text-white">
                        <h2>Notre Conseil d’Administration</h2>
                        <ul class="text-gray-200">
                            <li><a routerLink="/" class="hover:underline">Accueil</a></li>
                            <li>Conseil d’Administration</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

<div class="container py-5">
    <div class="section-title">
        @if(isOnHome){
            <h2>Notre Conseil d’Administration</h2>
            <div class="bar"></div>
        }
        <p>Une équipe engagée au service des communautés, pour porter la vision et les actions d’ASESA sur le terrain.</p>
    </div>

    <div class="row">

        <!-- Président -->
        <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
            <div class="single-team text-center">
                <div class="image">
                    <img src="assets/img/team/1.png" alt="FIFILIFI Ayefounin" class="img-fluid rounded">
                    <ul class="social">
                        <li><a href="tel:+22891181292" aria-label="Appeler le Président"><i class="fas fa-phone"></i></a></li>
                    </ul>
                </div>
                <div class="content mt-3">
                    <h4>FIFILIFI Ayefounin</h4>
                    <p>Président</p>
                </div>
            </div>
        </div>

        <!-- Secrétaire -->
        <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
            <div class="single-team text-center">
                <div class="image">
                    <img src="assets/img/team/2.png" alt="KPONFONDE Kossi Fabrice" class="img-fluid rounded">
                    <ul class="social">
                        <li><a href="tel:+22890885601" aria-label="Appeler le Secrétaire"><i class="fas fa-phone"></i></a></li>
                    </ul>
                </div>
                <div class="content mt-3">
                    <h4>KPONFONDE Kossi Fabrice</h4>
                    <p>Secrétaire</p>
                </div>
            </div>
        </div>

        <!-- Trésorier -->
        <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
            <div class="single-team text-center">
                <div class="image">
                    <img src="assets/img/team/3.png" alt="TCHALLA Komlan" class="img-fluid rounded">
                    <ul class="social">
                        <li><a href="tel:+22891755473" aria-label="Appeler le Trésorier"><i class="fas fa-phone"></i></a></li>
                    </ul>
                </div>
                <div class="content mt-3">
                    <h4>TCHALLA Komlan</h4>
                    <p>Trésorier</p>
                </div>
            </div>
        </div>

        <!-- 1er Conseiller -->
        <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
            <div class="single-team text-center">
                <div class="image">
                    <img src="assets/img/team/4.png" alt="AGUIDI Sena" class="img-fluid rounded">
                    <ul class="social">
                        <li><a href="tel:+22891462337" aria-label="Appeler le 1er Conseiller"><i class="fas fa-phone"></i></a></li>
                    </ul>
                </div>
                <div class="content mt-3">
                    <h4>AGUIDI Sena</h4>
                    <p>1er Conseiller</p>
                </div>
            </div>
        </div>

        <!-- 2ème Conseillère -->
        <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
            <div class="single-team text-center">
                <div class="image">
                    <img src="assets/img/team/5.png" alt="TCHAKAN Adjoa" class="img-fluid rounded">
                    <ul class="social">
                        <li><a href="tel:+22893921828" aria-label="Appeler la 2ème Conseillère"><i class="fas fa-phone"></i></a></li>
                    </ul>
                </div>
                <div class="content mt-3">
                    <h4>TCHAKAN Adjoa</h4>
                    <p>2ème Conseillère</p>
                </div>
            </div>
        </div>

    </div>
</div>
